import { userHasRight } from "../../core/rights";
import { Container, ContainerOptions } from "./container";
import { Editor } from "./editor";
import { TextArea } from "./textArea";

export interface NotesOptions extends ContainerOptions {
    editorId: string;
    textAreaId: string;
    requiredRight?: string;
}

export class Notes extends Container {

    options: NotesOptions;

    constructor(options: NotesOptions) {
        super({
            components: [
                new Editor({
                    id: options.editorId,
                    classes: "notes-textarea",
                    containerClasses: "notes-textarea-container",
                    bsc: "col-md-4 col-lg-6",
                    requiredRight: options.requiredRight
                }),
                new TextArea({
                    id: options.textAreaId,
                    classes: "notes-textarea",
                    containerClasses: "notes-textarea-container",
                    bsc: "col-md-4 col-lg-6",
                    placeholder: options.requiredRight
                        ? userHasRight(options.requiredRight)
                            ? "NotePlaceholder"
                            : undefined
                        : "NotePlaceholder",
                    requiredRight: options.requiredRight
                })
            ]
        });

        this.options = options;
    }
}
